<template>
    <v-card width="500px" class="mx-auto mt-5">
        <v-card-title>
            <div class="notfound">このページは存在しません</div>
        </v-card-title>
        <v-card-text>
            <router-link to="/">TOPへ戻る</router-link>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    title: "エラー",
}
</script>